import { render } from "./TemplateDivider.vue?vue&type=template&id=0937ee79&scoped=true"
const script = {}

import "./TemplateDivider.vue?vue&type=style&index=0&id=0937ee79&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0937ee79"]])

export default __exports__